













































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";
import router from "@/router";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class ImageTextSection extends Vue {
  newsApi = new NewsApi();
  dataList1: Array<object> = [];
  dataList2: Array<object> = [];
  dataList3: Array<object> = [];
  categorys: Array<object> = [{}, {}, {}];
  banner: object = {};
  parentId = 0;

  constructor() {
    super();
    // "究酒99", "名庄风采", "高手在民间"
    this.parentId = Number(this.$route.query["parentId"]);
    // this.categorys = ["风土", "酒庄", "酒类"];
  }

  mounted() {
    this.newsApi.getContentTypesByParentId(this.parentId).then((res) => {
      this.categorys = res.data;
    });

    this.newsApi.getImageTextSection(this.parentId).then((res) => {
      this.dataList1 = res.data.imageTextList1;
      this.dataList2 = res.data.imageTextList2;
      this.dataList3 = res.data.imageTextList3;
      this.banner = res.data.banner;
    });
  }
}
